import type { FormElement, ValueType, Validator } from './types';

export function getDefaultValue(element: FormElement) {
  if (element.ui === 'text' || element.ui === 'amount') {
    return '';
  } else if (element.ui === 'date') {
    return null;
  } else if (element.ui === 'select') {
    return null;
  }

  if ('type' in element) {
    switch (element.type) {
      case 'boolean':
        return false;
      case 'number':
        return 0;
      case 'string':
        return '';
      default:
        return '';
    }
  }
  return null;
}

export function buildDefaults(
  elements: FormElement[]
): Record<string, ValueType | null> {
  const values: Record<string, ValueType | null> = {};
  return elements.reduce((acc, element) => {
    if ('name' in element) {
      acc[element.name] = element.default ?? getDefaultValue(element);
    }
    return acc;
  }, values);
}

export function getErrorMessage(
  validate: Validator | Validator[] | undefined,
  name: string,
  values: Record<string, ValueType | null>
) {
  if (!validate) {
    return undefined;
  }

  const value = values[name];

  validate = Array.isArray(validate) ? validate : [validate];

  for (const v of validate) {
    const error = v(value, values);

    if (error === false) {
      return true;
    }

    if (error === true) {
      return undefined;
    }

    if (error) {
      return error;
    }
  }

  return undefined;
}
